module.exports = __webpack_public_path__ + "static/media/fi.72c6685e.svg";